import {merge} from 'lodash/fp'

/** 초기 상태와 업데이트 상태를 받아 새로운 상태를 생성하는 함수 */
export const createStateMaker =
    <S>(initializer: () => S) =>
    (args: Partial<S>): S =>
        merge(initializer(), args)
